import React from "react";
import { useBuilder, BlockConfig } from "../BuilderContext";

const fmt = (cents: number) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(cents / 100);

const PaymentHistoryBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state } = useBuilder();
  const heading = block.settings.headingOverride || "Payment History";

  const payments = state.documentType === "invoice" ? state.existingPayments : state.payments;

  if (!payments || payments.length === 0) {
    return (
      <div className="py-4">
        <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">{heading}</p>
        <p className="text-sm text-slate-400 text-center py-4">No payments recorded</p>
      </div>
    );
  }

  return (
    <div className="py-4">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">{heading}</p>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b-2" style={{ borderColor: "var(--color-primary)" }}>
            <th className="text-left py-2 text-xs font-semibold text-slate-600">Date</th>
            <th className="text-left py-2 text-xs font-semibold text-slate-600">Method</th>
            <th className="text-left py-2 text-xs font-semibold text-slate-600">Reference</th>
            <th className="text-right py-2 text-xs font-semibold text-slate-600">Amount</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p: any, i: number) => (
            <tr key={p._id || i} className="border-b border-slate-100">
              <td className="py-2 text-slate-800">
                {p.receivedAt ? new Date(p.receivedAt).toLocaleDateString("en-CA") : "-"}
              </td>
              <td className="py-2 text-slate-600 capitalize">{p.source || "-"}</td>
              <td className="py-2 text-slate-500 text-xs">
                {p.methodDetails?.chequeNumber || p.methodDetails?.eftReference || p.stripe?.chargeId || "-"}
              </td>
              <td className="py-2 text-right font-medium text-emerald-700">{fmt(p.amountCents)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentHistoryBlock;
